import { useDispatch } from 'react-redux'
import { AppDispatch } from 'featureSliced/shared/store'

export const useMyDispatch = () => useDispatch<AppDispatch>()
